(() => {
  const ZOOM = 2.4;

  const init = () => {
    const gallery = document.querySelector('[data-rm-gallery]');
    if (!gallery || gallery.dataset.rmGalleryReady === '1') return;
    gallery.dataset.rmGalleryReady = '1';

    const main = gallery.querySelector('[data-rm-gallery-main]');
    const thumbs = [...gallery.querySelectorAll('[data-rm-gallery-thumb]')];
    const zoomBtn = gallery.querySelector('[data-rm-zoom]');
    let lightbox = gallery.querySelector('[data-rm-lightbox]') || document.querySelector('[data-rm-lightbox]');

    if (!lightbox) {
      lightbox = document.createElement('div');
      lightbox.className = 'rm-lightbox';
      lightbox.setAttribute('data-rm-lightbox', '');
      lightbox.hidden = true;
      lightbox.innerHTML =
        '<button type="button" class="rm-lightbox__close" data-rm-lightbox-close aria-label="Fermer">×</button>' +
        '<div class="rm-lightbox__stage" data-rm-lightbox-stage><img src="" alt="" data-rm-lightbox-img></div>' +
        '<p class="rm-lightbox__hint" data-rm-lightbox-hint>Cliquer pour zoomer</p>';
    }

    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    const stage = lightbox.querySelector('[data-rm-lightbox-stage]');
    const lightboxImg = lightbox.querySelector('[data-rm-lightbox-img]');
    const lightboxClose = lightbox.querySelector('[data-rm-lightbox-close]');
    const hint = lightbox.querySelector('[data-rm-lightbox-hint]');
    let index = Math.max(
      0,
      thumbs.findIndex((t) => t.classList.contains('is-active'))
    );
    let scale = 1;
    let tx = 0;
    let ty = 0;
    let pointer = null;

    const fullSrc = () => {
      if (main?.dataset.full) return main.dataset.full;
      const active = thumbs[index];
      return active?.dataset.full || main?.currentSrc || main?.src || '';
    };

    const paint = (animate) => {
      if (!lightboxImg) return;
      lightbox.classList.toggle('is-zoomed', scale > 1);
      lightbox.classList.toggle('is-dragging', Boolean(pointer && pointer.moved));
      lightboxImg.style.transition = animate ? '' : 'none';
      lightboxImg.style.transform = `translate3d(${tx}px, ${ty}px, 0) scale(${scale})`;
      if (hint) {
        const en = (document.documentElement.lang || '').toLowerCase().startsWith('en');
        hint.textContent = scale > 1
          ? (en ? 'Drag · click to zoom out' : 'Glisser · cliquer pour réduire')
          : (en ? 'Click to zoom' : 'Cliquer pour zoomer');
      }
    };

    const clampPan = () => {
      if (!stage || scale <= 1) {
        tx = 0;
        ty = 0;
        return;
      }
      const rect = stage.getBoundingClientRect();
      const maxX = (rect.width * (scale - 1)) / 2;
      const maxY = (rect.height * (scale - 1)) / 2;
      tx = Math.max(-maxX, Math.min(maxX, tx));
      ty = Math.max(-maxY, Math.min(maxY, ty));
    };

    const resetZoom = () => {
      scale = 1;
      tx = 0;
      ty = 0;
      pointer = null;
      paint(true);
    };

    const setMain = (thumb) => {
      if (!main || !thumb) return;
      main.src = thumb.dataset.src || thumb.dataset.full || '';
      if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
      main.alt = thumb.dataset.alt || '';
      if (thumb.dataset.full) main.dataset.full = thumb.dataset.full;
    };

    const showInLightbox = () => {
      if (!lightboxImg) return;
      const src = fullSrc();
      if (!src) return;
      lightboxImg.removeAttribute('srcset');
      if (lightboxImg.getAttribute('src') !== src) lightboxImg.src = src;
      lightboxImg.alt = main?.alt || '';
    };

    const activate = (i) => {
      if (!thumbs.length) return;
      index = ((i % thumbs.length) + thumbs.length) % thumbs.length;
      const thumb = thumbs[index];
      thumbs.forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      setMain(thumb);
      if (lightbox.classList.contains('is-open')) {
        resetZoom();
        showInLightbox();
      }
    };

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', (event) => {
        event.stopPropagation();
        activate(i);
      });
    });

    const openLightbox = (event) => {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      if (!lightbox || !lightboxImg || !main) return;
      resetZoom();
      showInLightbox();
      lightbox.hidden = false;
      lightbox.removeAttribute('hidden');
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      resetZoom();
      lightbox.classList.remove('is-open');
      lightbox.hidden = true;
      lightbox.setAttribute('hidden', '');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    const zoomAt = (clientX, clientY) => {
      if (!stage) return;
      const rect = stage.getBoundingClientRect();
      const ox = clientX - (rect.left + rect.width / 2);
      const oy = clientY - (rect.top + rect.height / 2);
      scale = ZOOM;
      tx = -ox * (scale - 1);
      ty = -oy * (scale - 1);
      clampPan();
      paint(true);
    };

    stage?.addEventListener('pointerdown', (event) => {
      pointer = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY,
        tx,
        ty,
        moved: false,
        scale,
      };
      if (scale > 1) stage.setPointerCapture(event.pointerId);
    });

    stage?.addEventListener('pointermove', (event) => {
      if (!pointer || pointer.id !== event.pointerId || scale <= 1) return;
      const dx = event.clientX - pointer.x;
      const dy = event.clientY - pointer.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) pointer.moved = true;
      tx = pointer.tx + dx;
      ty = pointer.ty + dy;
      clampPan();
      paint(false);
    });

    const endPointer = (event) => {
      if (!pointer || pointer.id !== event.pointerId) return;
      const moved = pointer.moved;
      const wasZoomed = pointer.scale > 1;
      pointer = null;
      lightbox.classList.remove('is-dragging');
      if (moved) {
        paint(true);
        return;
      }
      if (wasZoomed) resetZoom();
      else zoomAt(event.clientX, event.clientY);
    };

    stage?.addEventListener('pointerup', endPointer);
    stage?.addEventListener('pointercancel', (event) => {
      if (!pointer || pointer.id !== event.pointerId) return;
      pointer = null;
      lightbox.classList.remove('is-dragging');
      paint(true);
    });

    zoomBtn?.addEventListener('click', openLightbox);

    lightboxClose?.addEventListener('click', (event) => {
      event.stopPropagation();
      closeLightbox();
    });

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });

    document.addEventListener('keydown', (event) => {
      if (!lightbox.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        if (scale > 1) resetZoom();
        else closeLightbox();
      }
      if (event.key === 'ArrowRight' && thumbs.length > 1) activate(index + 1);
      if (event.key === 'ArrowLeft' && thumbs.length > 1) activate(index - 1);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
